import * as MuiMenuItem from '@mui/material/MenuItem'
import React from 'react'

export type MenuItemProps = MuiMenuItem.MenuItemProps

export function MenuItem({ children, ...props }: MenuItemProps) {
  return <MuiMenuItem.default {...props}>{children}</MuiMenuItem.default>
}
